import { Keypair, PublicKey } from "@solana/web3.js";
import { mnemonicToSeed } from "bip39";
import HDKey from "micro-key-producer/slip10";

export async function derive_keypairs_from_passphrase(passphrase: string) {
    // console.log('------passphrase------')
    // console.log(passphrase)
    const seed = await mnemonicToSeed(passphrase); // (mnemonic, password)
    // const hd = HDKey.fromMasterSeed(seed.toString('hex'));
    const hd = HDKey.fromMasterSeed(seed); // HD означает Hierarchical Determenistic
    const keypairs = [];
    for (let i = 0; i < 20; i++) {
        // m — master key
        // 44 — BIP44, откуда взялась эта схема деривации
        // 501 — код блокчейна SolanaIcon из списка SLIP44
        // ${i} — номер ключа
        // 0 — если бы здесь был 1, это был бы change_wallet. Понятие из блокчейно с UTXO, например Биткоина
        // В SolanaIcon вместо UTXO аккаунты, поэтому change_wallet'ы не нужны.
        // Апостроф означает что имея публичный ключ от этого уровня деривации
        // нельзя сгенерировать публичный ключ для следующего уровня(то есть после слэша)
        // У Соланы могут быть разные пути деривации. Я использую самый распространённый(Phantom). Ещё бывают:
        // m/44'/501'/0'/0 (Math Wallet) и m/44'/501'/0' (Trust Wallet) и m/44'/501'/0'/0/0 (Exodus)
        const path = `m/44'/501'/${i}'/0'`;

        const keypair = Keypair.fromSeed(hd.derive(path).privateKey);
        keypairs.push(keypair);
        // console.log(`${path} => ${keypair.publicKey.toBase58()}`);
    }
    return keypairs;
}

function areUint8ArraysEqual(arr1: Uint8Array, arr2: Uint8Array): boolean {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}

export async function getKeypairFromPublicKeyAndPassphrase(publicKey: PublicKey, passphrase: string) {
    const keypairs = await derive_keypairs_from_passphrase(passphrase);

    for (const keyPair of keypairs) {
        if (areUint8ArraysEqual(keyPair.publicKey.toBuffer(), publicKey.toBuffer())) {
            return keyPair;
        }
    }
}
